/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OfferProductSolarPanel } from '../models/OfferProductSolarPanel';
import type { PaginatedOfferProductSolarPanelList } from '../models/PaginatedOfferProductSolarPanelList';
import type { PatchedOfferProductSolarPanel } from '../models/PatchedOfferProductSolarPanel';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OffersProductSolarPanelsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedOfferProductSolarPanelList
     * @throws ApiError
     */
    public offersProductSolarPanelsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedOfferProductSolarPanelList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-solar-panels/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns OfferProductSolarPanel
     * @throws ApiError
     */
    public offersProductSolarPanelsCreate({
        requestBody,
    }: {
        requestBody: OfferProductSolarPanel,
    }): CancelablePromise<OfferProductSolarPanel> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offers-product-solar-panels/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductSolarPanel
     * @throws ApiError
     */
    public offersProductSolarPanelsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product solar panel.
         */
        id: number,
    }): CancelablePromise<OfferProductSolarPanel> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-solar-panels/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OfferProductSolarPanel
     * @throws ApiError
     */
    public offersProductSolarPanelsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product solar panel.
         */
        id: number,
        requestBody: OfferProductSolarPanel,
    }): CancelablePromise<OfferProductSolarPanel> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/offers-product-solar-panels/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductSolarPanel
     * @throws ApiError
     */
    public offersProductSolarPanelsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product solar panel.
         */
        id: number,
        requestBody?: PatchedOfferProductSolarPanel,
    }): CancelablePromise<OfferProductSolarPanel> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/offers-product-solar-panels/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public offersProductSolarPanelsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product solar panel.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/offers-product-solar-panels/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
